// Entorno de desarrollo / staging (rama develop)
export const environment = {
    production: false,
    GA_MEASUREMENT_ID: 'G-W5EQKF107S',
    apiUrl: 'https://staging-web-api.iki.health/',
    recaptchaSiteKey: '6LeU_hIsAAAAAGa_rtcGLzlzLb2L8ObGfNrYJFBF'
};
